import { create } from "zustand";

export const useContentStore = create((set) => ({
  isLoading: true,
  setIsLoading: (isLoading: boolean) => set({ isLoading: isLoading }),
  selectedThumbnails: [],
  setSelectedThumbnails: (selectedThumbnails: any) =>
    set({ selectedThumbnails: selectedThumbnails }),
  searchKeyword: "",
  setSearchKeyword: (searchKeyword: string) =>
    set({ searchKeyword: searchKeyword }),
  searchKeywordTemp: "",
  setSearchKeywordTemp: (searchKeywordTemp: string) =>
    set({ searchKeywordTemp: searchKeywordTemp }),
  videoUrl: "",
  setVideoUrl: (videoUrl: string) => set({ videoUrl: videoUrl }),
  isShowPlayer: false,
  setIsShowPlayer: (isShowPlayer: boolean) =>
    set({ isShowPlayer: isShowPlayer }),
  isShowDeleteDialog: false,
  setIsShowDeleteDialog: (isShowDeleteDialog: boolean) =>
    set({ isShowDeleteDialog: isShowDeleteDialog }),
  isShowDetails: false,
  setIsShowDetails: (isShowDetails: boolean) =>
    set({ isShowDetails: isShowDetails }),
  selectedCurrentTime: "",
  setSelectedCurrentTime: (selectedCurrentTime: string) =>
    set({ selectedCurrentTime: selectedCurrentTime }),
  isShowEdit: false,
  setIsShowEdit: (isShowEdit: boolean) => set({ isShowEdit: isShowEdit }),
  selectedTime: "00:00:00",
  setSelectedTime: (selectedTime: string) =>
    set({ selectedTime: selectedTime }),
  tagDetails: [],
  setTagDetails: (tagDetails: any) => set({ tagDetails: tagDetails }),
  isModify: false,
  setIsModify: (isModify: boolean) => set({ isModify: isModify }),
  isSelected: false,
  setIsSelected: (isSelected: boolean) => set({ isSelected: isSelected }),
  filterTypes: "",
  setFilterTypes: (filterTypes: any) => set({ filterTypes: filterTypes }),
  isShowRetagDialog: false,
  setIsShowRetagDialog: (isShowRetagDialog: boolean) =>
    set({ isShowRetagDialog: isShowRetagDialog }),
  isShowMoveDialog: false,
  setIsShowMoveDialog: (isShowMoveDialog: boolean) =>
    set({ isShowMoveDialog: isShowMoveDialog }),
  selectedFolders: [],
  setSelectedFolders: (selectedFolders: any) =>
    set({ selectedFolders: selectedFolders }),
  sortOrder: 0,
  setSortOrder: (sortOrder: any) => set({ sortOrder: sortOrder }),
  sortField: "title",
  setSortField: (sortField: any) => set({ sortField: sortField }),
  isShowDeleteTagDialog: false,
  setIsShowDeleteTagDialog: (isShowDeleteTagDialog: boolean) =>
    set({ isShowDeleteTagDialog: isShowDeleteTagDialog }),
  isShowAddTagDialog: false,
  setIsShowAddTagDialog: (isShowAddTagDialog: boolean) =>
    set({ isShowAddTagDialog: isShowAddTagDialog }),
  isShowEditTagDialog: false,
  setIsShowEditTagDialog: (isShowEditTagDialog: boolean) =>
    set({ isShowEditTagDialog: isShowEditTagDialog }),
  isShowRenameDialog: false,
  setIsShowRenameDialog: (isShowRenameDialog: boolean) =>
    set({ isShowRenameDialog: isShowRenameDialog }),
}));
